/**
 * Greeting Card Auto-Cleanup
 * Mirrors gift-wrap-cleanup.js — removes greeting card line items from cart
 * when their linked gift pack variant is no longer present.
 *
 * Greeting card items are identified by the presence of properties['_part_of_bundle'].
 * The linked gift pack variant is stored in properties['_bundle_variant_id'].
 */

(function ($) {
  'use strict';

  var GreetingCardCleanup = {
    followupTimers: [],

    init: function () {
      this.bindEvents();
      setTimeout(this.cleanupOrphans.bind(this), 700);
    },

    bindEvents: function () {
      var self = this;

      // On remove button click: snapshot cart, wait for change, then clean up
      $(document).on('click', '.cart__remove, .ajax-cart__delete, [data-ajax-cart-delete]', function () {
        $.getJSON('/cart.js').done(function (cartBefore) {
          self.waitForCartChange(cartBefore, 3000)
            .then(function () {
              self.cleanupOrphansWithRefresh();
              self.scheduleFollowupCleanup();
            })
            .catch(function () {
              self.cleanupOrphansWithRefresh();
              self.scheduleFollowupCleanup();
            });
        }).fail(function () {
          setTimeout(function () {
            self.cleanupOrphansWithRefresh();
            self.scheduleFollowupCleanup();
          }, 700);
        });
      });

      // Theme cart events
      $(document).on('cart:updated ajaxCart.success cart.requestComplete cart:refresh ajaxCart.updated', function () {
        setTimeout(function () {
          self.cleanupOrphansWithRefresh();
          self.scheduleFollowupCleanup();
        }, 80);
      });

      // DOM mutation observer on cart containers
      this.observeCartDOM();
    },

    observeCartDOM: function () {
      try {
        var cartContainer = document.querySelector('.cart-items, .ajax-cart__products, .cart__cards, .ajax-cart__list');
        if (!cartContainer) return;
        var self = this;
        var mo = new MutationObserver(function () {
          if (self._domTimer) clearTimeout(self._domTimer);
          self._domTimer = setTimeout(function () {
            self.cleanupOrphansWithRefresh();
          }, 220);
        });
        mo.observe(cartContainer, { childList: true, subtree: true });
      } catch (err) {
        // ignore
      }
    },

    scheduleFollowupCleanup: function () {
      var self = this;
      if (this.followupTimers && this.followupTimers.length) {
        this.followupTimers.forEach(function (id) { clearTimeout(id); });
      }
      this.followupTimers = [
        setTimeout(function () { self.cleanupOrphansWithRefresh(); }, 600),
        setTimeout(function () { self.cleanupOrphansWithRefresh(); }, 1400)
      ];
    },

    waitForCartChange: function (cartBefore, timeoutMs) {
      var interval = 200;
      var elapsed = 0;
      return new Promise(function (resolve, reject) {
        function check() {
          $.getJSON('/cart.js').done(function (cartNow) {
            var beforeKeys = (cartBefore && cartBefore.items || []).map(function (i) { return i.key; }).sort().join(',');
            var nowKeys = (cartNow && cartNow.items || []).map(function (i) { return i.key; }).sort().join(',');
            var beforeQtys = (cartBefore && cartBefore.items || []).map(function (i) { return i.product_title + '::' + i.quantity; }).join('||');
            var nowQtys = (cartNow && cartNow.items || []).map(function (i) { return i.product_title + '::' + i.quantity; }).join('||');
            if (beforeKeys !== nowKeys || beforeQtys !== nowQtys) {
              resolve(cartNow);
              return;
            }
            elapsed += interval;
            if (elapsed >= timeoutMs) { reject(new Error('timeout')); return; }
            setTimeout(check, interval);
          }).fail(function () {
            elapsed += interval;
            if (elapsed >= timeoutMs) return reject(new Error('timeout'));
            setTimeout(check, interval);
          });
        }
        setTimeout(check, 80);
      });
    },

    isGreetingCardItem: function (item) {
      return !!(item.properties && item.properties['_part_of_bundle']);
    },

    getBundleVariantId: function (item) {
      return item.properties && item.properties['_bundle_variant_id']
        ? String(item.properties['_bundle_variant_id'])
        : null;
    },

    cleanupOrphans: function () {
      var self = this;
      $.getJSON('/cart.js').done(function (cart) {
        var cardItems = [];
        var packVariantIds = [];

        cart.items.forEach(function (item) {
          if (self.isGreetingCardItem(item)) {
            cardItems.push(item);
          } else {
            if (item.variant_id) packVariantIds.push(String(item.variant_id));
          }
        });

        cardItems.forEach(function (card) {
          var linkedId = self.getBundleVariantId(card);
          if (!linkedId) return;
          var packExists = packVariantIds.indexOf(linkedId) !== -1;
          if (!packExists) {
            self.removeItem(card.key, false);
          }
        });
      });
    },

    cleanupOrphansWithRefresh: function () {
      var self = this;
      $.getJSON('/cart.js').done(function (cart) {
        var cardItems = [];
        var packVariantIds = [];
        var orphansFound = false;

        cart.items.forEach(function (item) {
          if (self.isGreetingCardItem(item)) {
            cardItems.push(item);
          } else {
            if (item.variant_id) packVariantIds.push(String(item.variant_id));
          }
        });

        cardItems.forEach(function (card) {
          var linkedId = self.getBundleVariantId(card);
          if (!linkedId) return;
          var packExists = packVariantIds.indexOf(linkedId) !== -1;
          if (!packExists) {
            orphansFound = true;
            self.removeItem(card.key, true);
          }
        });
      });
    },

    removeItem: function (cartKey, shouldRefresh) {
      var self = this;
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { id: cartKey, quantity: 0 },
        dataType: 'json',
        success: function () {
          if (shouldRefresh) {
            $(document).trigger('cart:updated');
            if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
              try { window.PXUTheme.jsAjaxCart.updateView(); } catch (e) { /* ignore */ }
            }
            if (window.location.pathname.indexOf('/cart') !== -1) {
              setTimeout(function () {
                try { location.reload(); } catch (e) { /* ignore */ }
              }, 450);
            }
          }
        }
      });
    }
  };

  $(document).ready(function () {
    GreetingCardCleanup.init();
  });

  $(document).on('cart:loaded ajaxCart.init', function () {
    setTimeout(function () { GreetingCardCleanup.cleanupOrphans(); }, 300);
  });

})(jQuery);
